import { Component, Input } from '@angular/core'
import { OfferForm } from '../../components/offer-form/offer-form'
import { ComponentBase } from '../../intefaces/interfaces'
import { NgOptimizedImage } from '@angular/common'

@Component({
	selector: 'app-header-with-floating-offer-form',
	imports: [OfferForm, NgOptimizedImage],
	templateUrl: './header-with-floating-offer-form.html',
	styleUrl: './header-with-floating-offer-form.css',
})
export class HeaderWithFloatingOfferForm {
	@Input() content!: ComponentBase
}
